class MainCrudController extends AbstractController
	@register angular.module 'App'

	# Translatable, {@legacy selected_header}
	entityTitle: 'create_new'
	# Translatable, used in form action buttons {@legacy item_type}
	entityType: undefined
	description: undefined
	showFormActionButtons: true
	# @legacy !updating
	isNewEntity: false
	saving: false
	# @legacy !no_create, !no_update
	showSave: true
	# @legacy !no_delete
	showDelete: true

	# @legacy after_header_title
	afterHeaderTitle: null
	deletionAlertText: null
	tabs: undefined
	additionalButtons: []

	initialize: ->
		@reset()

	reset: ->
		@showFormActionButtons = true
		@isNewEntity = false
		@saving = false
		@showSave = true
		@showDelete = true
		@deletionAlertText = null
		@afterHeaderTitle = null
		@additionalButtons = []

		@parent_form?.$setPristine()
